import sources from 'helpers/sources';

import dateFormatter from 'helpers/date_formatter';

import plural from 'helpers/plural';

import {
  SMS_OPT_OUT_INSTRUCTIONS_POLICY_OPTIONS
} from 'react/types/sms_settings';

import {
  SMS_OPT_OUT_POLICY_HINT_TEXT
} from 'react/types/constants';

angular.module('gym.bulkMessages').controller('newBulkMessageCtrl', ["$scope", "$rootScope", "$state", "$stateParams", "$filter", "$http", "$timeout", "flash", "Contacts", "bulkMessageService", "EmploymentService", "SmsValidationService", "PushNotificationValidationService", "DefaultReplyAddressService", "AssetLibraryService", "PingService", "GTMService", "TestEmailsService", "TemplateValidationService", "PushNotificationOptionsService", "ReactModal", "gym", "templates", "reports", function($scope, $rootScope, $state, $stateParams, $filter, $http, $timeout, flash, Contacts, bulkMessageService, EmploymentService, SmsValidationService, PushNotificationValidationService, DefaultReplyAddressService, AssetLibraryService, PingService, GTMService, TestEmailsService, TemplateValidationService, PushNotificationOptionsService, ReactModal, gym, templates, reports) {
  var bulkMessage, contentValid, getEmailSenderAddresses, hasRecipients, isEmailSenderEligibleForWarning, isEmailValid, isPushNotificationValid, isSmsValid, sendBulkMessageChannel, sender, subjectValid, url;
  PingService.ping();
  $scope.gym = $rootScope.gym;
  $scope.permissions = EmploymentService.get().permissions;
  $scope.templates = templates;
  $scope.smsHintText = SMS_OPT_OUT_POLICY_HINT_TEXT;
  bulkMessage = bulkMessageService.get();
  $scope.reports = reports.map(function(item) {
    item.key = Math.floor(Math.random() * 1000000);
    return item;
  });
  GTMService.trackPage('New Bulk Message');
  $scope.hasEvent = !!$stateParams.eventId;
  $scope.hasInvoice = !!$stateParams.invoiceId;
  $scope.eventCancelled = false;
  if ($stateParams.eventId) {
    url = `/gyms/${$scope.gym.id}/calendar/events/${$stateParams.eventId}`;
    $http.get(url).then(function(response) {
      return $scope.eventCancelled = response.data.cancelled || false;
    });
  }
  $scope.recipients = bulkMessage.recipients;
  $scope.template = bulkMessage.template;
  $scope.pushNotificationRoutes = [
    {
      label: "No preference (open app to Notifications list)",
      value: ''
    }
  ];
  $scope.emailSenders = gym.attributes.reply_email_addresses;
  $scope.replyEmails = (function() {
    var i, len, ref, results;
    ref = $scope.emailSenders;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      sender = ref[i];
      results.push(sender.email);
    }
    return results;
  })();
  $scope.smsOptOutInstructionsOptions = SMS_OPT_OUT_INSTRUCTIONS_POLICY_OPTIONS;
  $scope.template.sms_opt_out_instructions_policy = $scope.template.sms_opt_out_instructions_policy || $scope.gym.presented_gym_sms_detail.sms_opt_out_instructions_policy;
  $scope.template.push_notification_route_name = $scope.template.push_notification_route_name || $scope.pushNotificationRoutes[0].value;
  $scope.pushNotificationRoutesContext = function() {
    if ($stateParams.from === 'calendar_event' || $scope.hasEvent) {
      return 'calendar_event';
    } else if ($stateParams.from === 'invoices' || $stateParams.from === 'contactInvoices') {
      return 'payment_list';
    } else {
      return '';
    }
  };
  $scope.loadPushNotificationRoutes = function() {
    return PushNotificationOptionsService.getOptions($scope.gym.id, $scope.pushNotificationRoutesContext()).then(function(data) {
      if (data.length) {
        return $scope.pushNotificationRoutes = $scope.pushNotificationRoutes.concat(data);
      } else {
        return $scope.pushNotificationRoutes = data;
      }
    }).catch(function(error) {
      return flash.error(error);
    });
  };
  $scope.loadPushNotificationRoutes();
  $scope.toggleAssetLibrary = function() {
    return AssetLibraryService.open({
      mode: 'select'
    }).then(function(asset) {
      $scope.template.push_notification_image_asset_id = asset.id;
      $scope.template.push_notification_image_url = asset.attached_url;
      return $scope.template.push_notification_image_thumb_url = asset.thumb_url;
    });
  };
  $scope.removeImage = function() {
    $scope.template.push_notification_image_asset_id = null;
    $scope.template.push_notification_image_url = null;
    return $scope.template.push_notification_image_thumb_url = null;
  };
  $scope.previewImage = function() {
    return ReactModal.open({
      component: 'PushNotificationImageModal',
      props: {
        imageUrl: $scope.template.push_notification_image_url,
        replaceImage: $scope.toggleAssetLibrary,
        removeImage: $scope.removeImage
      }
    });
  };
  $scope.checkEmailAuthorization = function(email) {
    var isEmailAuthorized;
    isEmailAuthorized = $scope.emailSenders.find(function(item) {
      return item.email === email;
    });
    if (isEmailAuthorized) {
      return isEmailAuthorized.authorized;
    } else {
      return false;
    }
  };
  $scope.showEmailVerificationWarning = function(email) {
    var matchingSender;
    matchingSender = $scope.emailSenders.find(function(item) {
      return item.email === email;
    });
    if (matchingSender) {
      return !matchingSender.skip_warning;
    }
  };
  $scope.mobileAppEnabled = function() {
    var ref;
    return $scope.gym.mobile_app_enabled && ((ref = $rootScope.mobileAppMeta) != null ? ref.push_notifications_feature_enabled : void 0);
  };
  $scope.onTemplateChanged = function() {
    var base, base1, base2, base3, base4;
    $scope.template || ($scope.template = {});
    (base = $scope.template).reply_address || (base.reply_address = DefaultReplyAddressService.getDefaultEmail());
    (base1 = $scope.template).channel || (base1.channel = 'email');
    (base2 = $scope.template).push_notification_image_asset_id || (base2.push_notification_image_asset_id = $scope.template.push_notification_image_asset_id);
    (base3 = $scope.template).push_notification_image_url || (base3.push_notification_image_url = $scope.template.push_notification_image_url);
    return (base4 = $scope.template).push_notification_image_thumb_url || (base4.push_notification_image_thumb_url = $scope.template.push_notification_image_thumb_url);
  };
  $scope.onTemplateChanged();
  $scope.$on('$stateChangeStart', function(event, toState) {
    var ref;
    if ((ref = toState.data) != null ? ref.preserveBulkMessage : void 0) {
      return;
    }
    bulkMessageService.set({
      recipients: [],
      template: {
        reply_address: DefaultReplyAddressService.getDefaultEmail()
      }
    });
    $scope.recipients = [];
    return $scope.template = {
      reply_address: DefaultReplyAddressService.getDefaultEmail()
    };
  });
  $scope.loadReport = function($tag) {
    if ($tag.route === 'reports') {
      return $tag.get({
        include_recipients: 1
      }).then(function(tag) {
        return $tag.recipients = tag.recipients;
      });
    }
  };
  sendBulkMessageChannel = function(message) {
    switch (message.channel) {
      case 'email_message':
        return 'email';
      case 'sms_message':
        return 'sms';
      case 'push_notification_message':
        return 'push_notification';
      default:
        return 'email';
    }
  };
  getEmailSenderAddresses = function() {};
  url = `/gyms/${$scope.gym.id}/reply_email_addresses`;
  getEmailSenderAddresses = function() {};
  url = `/gyms/${$scope.gym.id}/reply_email_addresses`;
  $http.get(url).then(function(response) {
    if (!$scope.$$phase) {
      return $scope.$apply(function() {
        return $scope.emailSenders = response.data;
      });
    } else {
      return $timeout(function() {
        return $scope.emailSenders = response.data;
      });
    }
  });
  $scope.getSentBulkMessage = function() {
    if ($stateParams.bulkMessageId) {
      url = sources.bulkMessage($scope.gym.id, $stateParams.bulkMessageId);
      return $http.get(url).then(function(response) {
        var date, item, recipientsCount, sentBulkMessage;
        sentBulkMessage = response.data;
        $scope.template.channel = sendBulkMessageChannel(sentBulkMessage);
        date = dateFormatter(sentBulkMessage.created_at, 'mediumDate');
        recipientsCount = plural('recipients', sentBulkMessage.contact_comms_recipient_ids.length, true);
        item = {
          route: 'bulk_message',
          name: `Message sent ${date} (${recipientsCount})`,
          recipient_ids: response.data.contact_comms_recipient_ids
        };
        return $scope.recipients.push(item);
      });
    }
  };
  $scope.getSentBulkMessage();
  $scope.loadContacts = function(query) {
    return Contacts.getList({
      all_contacts_search: query
    }).then(function(contacts) {
      var data;
      data = _.union(contacts, $scope.reports).map(function(item) {
        if (item.route === 'contacts') {
          item.key = item.id;
        }
        return item;
      });
      return $filter('filter')(data, {
        name: query
      });
    });
  };
  $scope.openUnverifiedEmailSenderWarningModal = function(email, submitFunction) {
    return ReactModal.open({
      component: 'UnverifiedEmailSenderWarningModal',
      props: {
        unverifiedEmailAddress: email,
        onSubmit: submitFunction
      }
    });
  };
  $scope.submitTemplate = function() {
    $scope.loading = true;
    if ($scope.template.push_notification_route_name === '') {
      $scope.template.push_notification_route_name = null;
    }
    if ('push_notification_image_url' in $scope.template) {
      delete $scope.template.push_notification_image_url;
    }
    if ('push_notification_image_thumb_url' in $scope.template) {
      delete $scope.template.push_notification_image_thumb_url;
    }
    return bulkMessageService.set({
      recipients: $scope.recipients,
      template: $scope.template
    }).then(function() {
      $scope.loading = false;
      getEmailSenderAddresses();
      return $state.go('gym.bulkMessages.confirm', $stateParams);
    }).catch(function(error) {
      return $scope.loading = false;
    });
  };
  $scope.confirm = function() {
    if (isEmailSenderEligibleForWarning($scope.template)) {
      return $scope.openUnverifiedEmailSenderWarningModal($scope.template.reply_address, function() {
        return $scope.submitTemplate($scope.template);
      });
    } else {
      return $scope.submitTemplate($scope.template);
    }
  };
  isEmailSenderEligibleForWarning = function(template) {
    return template.channel === 'email' && !$scope.checkEmailAuthorization(template.reply_address) && $scope.showEmailVerificationWarning(template.reply_address);
  };
  isSmsValid = function() {
    return $scope.template.channel === 'sms' && $scope.gym.sms_enabled && SmsValidationService.isLengthValid($scope.template.content);
  };
  isEmailValid = function() {
    return $scope.template.channel === 'email' && subjectValid() && $scope.gym.custom_emails_enabled;
  };
  isPushNotificationValid = function() {
    return $scope.template.channel === 'push_notification' && subjectValid() && PushNotificationValidationService.isLengthValid($scope.template.content);
  };
  hasRecipients = function() {
    return _.find($scope.recipients, function(item) {
      return !item.recipients || item.recipients.length;
    });
  };
  $scope.isFreemiumWithoutPaymentMethod = function() {
    return $scope.template.channel === 'sms' && $scope.gym.on_freemium && !$scope.gym.subscription_payment_method_present && $scope.gym.sms_enabled;
  };
  $scope.requiresObject = function() {
    return $scope.template.requires_object && (($scope.template.requires_booking_object && !$scope.hasEvent) || ($scope.template.requires_membership_object && !$scope.hasEvent) || ($scope.template.requires_invoice_object && !$scope.hasInvoice) || $scope.template.requires_member_style_object || $scope.template.requires_member_grading_object || $scope.template.requires_contact_suspension_object || $scope.template.requires_recurring_booking_detail_object || $scope.template.requires_late_booking_cancellation_object || $scope.template.requires_booking_cancellation_object || $scope.template.requires_waitlist_attendee_object || $scope.template.requires_performed_workout_object);
  };
  subjectValid = function() {
    return TemplateValidationService.subjectIsNotEmpty($scope.template.subject);
  };
  contentValid = function() {
    return TemplateValidationService.contentIsNotEmpty($scope.template.content);
  };
  $scope.messageReady = function() {
    $scope.error = SmsValidationService.getErrors($scope.template);
    if ($scope.error) {
      return false;
    }
    if ($scope.isFreemiumWithoutPaymentMethod()) {
      return false;
    }
    return hasRecipients() && contentValid() && !$scope.requiresObject() && (isSmsValid() || isEmailValid() || isPushNotificationValid());
  };
  $scope.testEmailReady = function() {
    return subjectValid() && contentValid();
  };
  return $scope.sendTestEmail = function() {
    var contact, params;
    contact = $scope.recipients.length && $scope.recipients[0].first_name ? $scope.recipients[0] : void 0;
    params = {
      subject: $scope.template.subject,
      content: $scope.template.content,
      head_tag_content: $scope.template.head_tag_content,
      reply_address: window.currentUser.email,
      contact: contact
    };
    return TestEmailsService.sendTestEmail(params);
  };
}]);
